function initCustomRegionFieldSelect() {
  const variantsToggles = document.querySelectorAll('.custom_field_params .toggle_arrow');

  variantsToggles?.forEach(function (listToggle) {
    listToggle.addEventListener('click', function (e) {
      const list = this.closest('.form__card').querySelector('.select_variants');
      const inputs = list.querySelectorAll('input');

      if (list.classList.contains('d-none')) {
        this.classList.add('show');
        list.classList.remove('d-none');
      } else {
        this.classList.remove('show');
        list.classList.add('d-none');
      }
    });
  });
}

export { initCustomRegionFieldSelect }